"use strict";

export default class Exceptions {

    private message: string;
    private type: string;

    constructor(message, type) {
        this.message = message;
        this.type = type;
    }
}